import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { combineLatest, Observable, switchMap } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { NavigationService } from '@nk/app/core/services/navigation.service';
import { PageActionsService } from '@nk/ui-lib';
import { Breadcrumb, Tab } from '@nk/core/services/navigation.utils';

@Component({
  selector: 'nk-sub-navigation-top',
  templateUrl: './sub-navigation-top.component.html',
  styleUrls: ['./sub-navigation-top.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SubNavigationTopComponent implements OnInit {
  public hideAllBreadcrumbs = false; // populate // TODO: FIX
  public breadcrumbs$: Observable<Breadcrumb[]>;
  public tabs$: Observable<Tab[]>;
  public showSubNav$: Observable<boolean>;
  public tabs: Tab[];

  public readonly pageActions = inject(PageActionsService).actions;

  constructor(
    private _navigationService: NavigationService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
  ) {}

  public ngOnInit(): void {
    const navigationEnd$ = this._router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      startWith(this._router), // Does not work when going to an empty page first... for some reason?
    );

    this.breadcrumbs$ = navigationEnd$.pipe(map(() => this._navigationService.getBreadcrumbs(this._activatedRoute)));
    this.tabs$ = navigationEnd$.pipe(
      switchMap(() => this._navigationService.getActiveNavigationTab(this._activatedRoute)),
    );

    this.showSubNav$ = combineLatest([this.tabs$, this.breadcrumbs$]).pipe(
      map(([tabs, breadcrumbs]) => {
        return tabs.length > 0 || breadcrumbs.length > 1;
      }),
    );
  }
}
